////////LIBRARY/////////
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, rolesManagerActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getRoles = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	user['userMode'] = payload.userMode
	const apiCall = R.GET_ROLES(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		yield put(rolesManagerActionCreators.getRolesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rolesManagerActionCreators.getRolesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createRole = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_ROLE(user)
	const dataRole = payload.role
	let dataFomat = {
		nameNewRole: dataRole.roleName,
		level: dataRole.level,
	}

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFomat)

		// Prepare data to be added on current list
		let item = cloneDeep(data.data)
		// Set our newly created role to be editable and removable
		item.canBeModify = true
		item.canBeDelete = true
		item.level = dataRole.level

		yield put(rolesManagerActionCreators.createRoleSuccess(item))

		/* const modal = {
            level: 'validation',
            title: 'modal__roleManagement__create_placeholder',
            key: 'modal__roleManagement__create_validation_message',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__roleManagement__create'))
	} catch (e) {
		//yield put(rolesManagerActionCreators.createRoleSuccess(dataRole));

		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rolesManagerActionCreators.createRoleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const deleteRole = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idRole = payload.idRole
	user['idRole'] = idRole
	let apiCall

	yield put(globalLoadingActionCreators.startLoading())

	apiCall = R.DELETE_ROLE(user)

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(rolesManagerActionCreators.deleteRoleSuccess(idRole))

		/* const modal = {
            level: 'validation',
            title: 'modal__roleManagement__delete_placeholder',
            key: 'modal__roleManagement__delete_role',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__roleManagement__delete'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rolesManagerActionCreators.deleteRoleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getRoleDetail = function* ({ payload }) {
	const idRole = payload.idRole
	const user = yield select(selectIdsUser)
	user['idRole'] = idRole
	const apiCall = R.GET_ROLE_DETAIL(user)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(rolesManagerActionCreators.getRoleDetailSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rolesManagerActionCreators.getRoleDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateHeaderRole = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idRole = payload.idRole
	user['idRole'] = idRole
	const apiCall = R.UPDATE_HEADER_ROLE(user)
	const dataRole = payload.role
	let dataFomat = {
		nameNewRole: dataRole.roleName,
		level: dataRole.level,
	}

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFomat)

		// Prepare data to be refreshed on current list
		// Set our newly created role to be editable and removable
		let item = cloneDeep(data.data)
		item.id = idRole
		item.level = dataRole.level
		item.canBeModify = true
		item.canBeDelete = true
		item.label = dataRole.roleName

		yield put(rolesManagerActionCreators.updateHeaderRoleSuccess(item))

		/*  const modal = {
            level: 'validation',
            title: 'modal__roleManagement__edit_placeholder',
            key: 'modal__roleManagement__edit_validation_message',
            show: true,
            path: '',
            insideModalResponse: true
        };
 */
		yield put(toastSuccessActionCreators.hydrateToast('toast__roleManagement__update'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rolesManagerActionCreators.updateHeaderRoleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateContentRole = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idRole = payload.idRole
	user['idRole'] = idRole
	const apiCall = R.UPDATE_CONTENT_ROLE(user)
	const datas = payload.datas

	if (datas.users.length === 0) {
		datas.users = null
	}

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, datas)
		yield put(rolesManagerActionCreators.getRoles(false))
		yield put(rolesManagerActionCreators.updateContentRoleSuccess(data.data))

		/*   const modal = {
            level: 'validation',
            title: 'modal__roleManagement__validation_header',
            key: 'modal__roleManagement__validation_validation',
            show: true,
            path: '',
            insideModalResponse: true
        }; */

		yield put(toastSuccessActionCreators.hydrateToast('toast__roleManagement__applied'))
		yield put(rolesManagerActionCreators.getRoleDetail(idRole))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(rolesManagerActionCreators.updateContentRoleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ROLES, getRoles)
	yield takeLatest(ActionsTypes.CREATE_ROLE, createRole)
	yield takeLatest(ActionsTypes.DELETE_ROLE, deleteRole)
	yield takeLatest(ActionsTypes.GET_ROLE_DETAIL, getRoleDetail)
	yield takeLatest(ActionsTypes.UPDATE_HEADER_ROLE, updateHeaderRole)
	yield takeLatest(ActionsTypes.UPDATE_CONTENT_ROLE, updateContentRole)
}

export default sagas
